// No direct PHP counterpart.
// Shared JS helper for:
// - api/fuel/app/classes/controller/api/monty/tags/add.php
// - api/fuel/app/classes/controller/api/monty/tags/clear.php
// - api/fuel/app/classes/controller/api/monty/tags/create.php
// - api/fuel/app/classes/controller/api/monty/tags/delete.php
// - api/fuel/app/classes/controller/api/monty/tags/family/create.php
// - api/fuel/app/classes/controller/api/monty/tags/family/delete.php
// - api/fuel/app/classes/controller/api/monty/tags/family/update.php
// - api/fuel/app/classes/controller/api/monty/tags/move.php
// - api/fuel/app/classes/controller/api/monty/tags/remove.php
// - api/fuel/app/classes/controller/api/monty/tags/toggle.php
// - api/fuel/app/classes/controller/api/monty/tags/update.php
import DB from 'offline/db'
import Constants from 'offline/constants'

export function sessionUserId(params) {
	return params.sessionUserId || DB.meta('sync_user_id') || false
}

export function unauthorised() {
	return Promise.reject({ error: Constants.API_ERROR_UNAUTHORISED, offline: true })
}

export function invalid() {
	return Promise.reject({ error: Constants.API_ERROR_INVALID, offline: true })
}

export function success(data) {
	return Promise.resolve({
		session: { offline: true },
		data: data
	})
}

export function persist(data) {
	return DB.save().then(function() {
		return {
			session: { offline: true },
			data: data
		}
	})
}

export function uniqueIndex(index) {
	var seen = {}
	var result = []
	var input = Array.isArray(index) ? index : [index]

	for (var i = 0; i < input.length; i++) {
		var value = parseInt(input[i], 10) || 0
		if (value && !seen[value]) {
			seen[value] = true
			result.push(value)
		}
	}

	return result
}

export function tagToArray(row) {
	return {
		id: parseInt(row.tag_id, 10) || 0,
		family: parseInt(row.family_id, 10) || 0,
		context: parseInt(row.tag_context, 10) || 0,
		public: parseInt(row.tag_public, 10) || 0,
		text: row.tag_text || '',
		colour: row.tag_colour || '',
		fore: row.tag_fore || '',
		attachments: parseInt(row.tag_attachments, 10) || 0
	}
}

export function familyToArray(row) {
	return {
		id: parseInt(row.family_id, 10) || 0,
		type: parseInt(row.family_type, 10) || 0,
		context: parseInt(row.family_context, 10) || 0,
		public: parseInt(row.family_public, 10) || 0,
		style: parseInt(row.family_style, 10) || 0,
		name: row.family_name || '',
		colour: row.family_colour || '',
		fore: row.family_fore || '',
		attachments: parseInt(row.family_attachments, 10) || 0
	}
}

export function attachField(context) {
	if (context === Constants.TAG_CONTEXT_GAME) return 'game_id'
	if (context === Constants.TAG_CONTEXT_COLLECTION) return 'collection_id'
	if (context === Constants.TAG_CONTEXT_RATING) return 'rating_id'
	if (context === Constants.TAG_CONTEXT_PLAY) return 'play_id'
	return false
}

export function loadOwnedTag(userId, tagId) {
	var rows = DB.query('SELECT * FROM tag WHERE tag_id = ? AND user_id = ? LIMIT 1', [
		parseInt(tagId, 10) || 0,
		parseInt(userId, 10) || 0
	])
	return rows.length ? rows[0] : null
}

export function loadOwnedFamily(userId, familyId) {
	var rows = DB.query('SELECT * FROM tag_family WHERE family_id = ? AND user_id = ? LIMIT 1', [
		parseInt(familyId, 10) || 0,
		parseInt(userId, 10) || 0
	])
	return rows.length ? rows[0] : null
}

export function validateTagData(data) {
	var text = String(data.text || '').trim()
	var context = parseInt(data.context, 10)
	var isPublic = parseInt(data.public, 10)

	if (!text) return false
	if (context < Constants.TAG_CONTEXT_GAME || context > Constants.TAG_CONTEXT_PLAY) return false
	if (isPublic !== 0 && isPublic !== 1) return false
	if (data.colour === undefined || data.colour === null) return false
	if (data.fore === undefined || data.fore === null) return false
	return true
}

export function validateFamilyData(data) {
	var name = String(data.name || '').trim()
	var context = parseInt(data.context, 10)
	var isPublic = parseInt(data.public, 10)
	var type = parseInt(data.type, 10)
	var style = parseInt(data.style, 10)

	if (!name) return false
	if (context < Constants.TAG_CONTEXT_GAME || context > Constants.TAG_CONTEXT_PLAY) return false
	if (isPublic !== 0 && isPublic !== 1) return false
	if (type !== 0 && type !== 1) return false
	if (style !== 0 && style !== 1) return false
	return true
}

export function updateTagAttachmentCounts(tagIds) {
	var index = uniqueIndex(tagIds)

	for (var i = 0; i < index.length; i++) {
		var count = parseInt(DB.scalar('SELECT COUNT(*) FROM tag_attach WHERE tag_id = ?', [index[i]]), 10) || 0
		DB.run('UPDATE tag SET tag_attachments = ? WHERE tag_id = ?', [count, index[i]])
	}
}

export function updateFamilyAttachmentCounts(familyIds) {
	var index = uniqueIndex(familyIds)

	for (var i = 0; i < index.length; i++) {
		var count = parseInt(DB.scalar('SELECT COUNT(*) FROM tag_attach WHERE family_id = ?', [index[i]]), 10) || 0
		DB.run('UPDATE tag_family SET family_attachments = ? WHERE family_id = ?', [count, index[i]])
	}
}

export function touchAttachmentCounts(tagIds, familyIds) {
	updateTagAttachmentCounts(tagIds)
	updateFamilyAttachmentCounts(familyIds)
}

export function familyTagIds(familyId, excludeTagId) {
	var sql = 'SELECT tag_id FROM tag WHERE family_id = ?'
	var params = [parseInt(familyId, 10) || 0]

	if (excludeTagId) {
		sql += ' AND tag_id <> ?'
		params.push(parseInt(excludeTagId, 10) || 0)
	}

	return DB.query(sql, params).map(function(row) {
		return parseInt(row.tag_id, 10) || 0
	}).filter(Boolean)
}
